import { Col, Modal, Row, theme, Tooltip } from "antd";
import { useRef, useState } from "react";
import {
  FeedbackEntry,
  FeedbackFormRef,
  FeedbackItemType,
  FeedbackReplyStatus,
} from "@/components/HeaderFeedback/types";
import FeedbackForm from "@/components/HeaderFeedback/FeedbackForm";
import FeedbackList from "@/components/HeaderFeedback/FeedbackList";
import FeedbackDetail from "@/components/HeaderFeedback/FeedbackDetail";
import YsIcon from "@/components/Iconfont";
import { sendLog } from "@/utils/tracker";
import { useQueryClient } from "@tanstack/react-query";

const optionsTab = [
  {
    label: "我要反馈",
    value: FeedbackEntry.FEEDBACK,
  },
  {
    label: "反馈记录",
    value: FeedbackEntry.RECORD,
  },
];

const HeaderFeedback = () => {
  const { token: globalToken } = theme.useToken();
  const queryClient = useQueryClient();
  const formRef = useRef<FeedbackFormRef>(null);
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(FeedbackEntry.FEEDBACK);
  const [feedbackData, setFeedbackData] = useState<FeedbackItemType | null>(
    null,
  );

  const handleViewFeedbackModal = () => {
    setOpen(true);
    sendLog("pcMainFloatingFrame", "主悬浮框", {
      click_source: "反馈",
    });
    sendLog("pcFeedback", "意见反馈", {
      click_source: "tab",
      tab_name: "我要反馈",
    });
  };

  const handleCloseFeedbackModal = () => {
    setOpen(false);
    formRef.current?.onReset();
    setFeedbackData(null);
    setActiveTab(FeedbackEntry.FEEDBACK);
  };

  const handleClickFeedbackItem = (feedbackData: FeedbackItemType) => {
    setFeedbackData(feedbackData);
    setActiveTab(FeedbackEntry.RECORD_DETAIL);
    sendLog("pcFeedback", "意见反馈", {
      click_source: "查看详情",
      tab_name: "反馈记录",
      reply_status:
        feedbackData.handleStatus === FeedbackReplyStatus.REPLIED
          ? "已回复"
          : "未回复",
    });
  };

  const handleSubmitSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [`/manage/complaint/list`],
      refetchType: "all",
    });
  };

  const handleBackList = () => {
    setActiveTab(FeedbackEntry.RECORD);
  };

  const handleClickTab = (value: FeedbackEntry) => {
    setActiveTab(value);
    sendLog("pcFeedback", "意见反馈", {
      click_source: "tab",
      tab_name: value === FeedbackEntry.FEEDBACK ? "我要反馈" : "反馈记录",
    });
  };

  return (
    <>
      <Tooltip title="意见反馈" color={globalToken.colorPrimary}>
        <YsIcon
          type="icon-fankui"
          className="p-2 cursor-pointer hover:bg-[rgba(0,0,0,0.025)] text-2xl"
          onClick={handleViewFeedbackModal}
        />
      </Tooltip>
      <Modal
        open={open}
        title="意见反馈"
        styles={{
          header: {
            marginBottom: 0,
            padding: "20px 24px",
            borderBottom: "1px solid #eee",
          },
          body: { borderRadius: "8px", overflow: "hidden" },
          content: { padding: "0 0 0 0" },
        }}
        width={1000}
        footer={false}
        maskClosable={false}
        onCancel={handleCloseFeedbackModal}
      >
        <Row className="h-[560px]" wrap={false}>
          <Col flex="200px">
            <div className="bg-white p-2 h-full overflow-y-auto">
              {optionsTab?.map((item) => (
                <div
                  key={item.value}
                  className="w-full box-border h-10 pl-10 mb-2 flex flex-row items-center rounded cursor-pointer hover:bg-[rgba(255,199,18,0.1)]"
                  style={{
                    background:
                      activeTab === item.value ||
                      (item.value === FeedbackEntry.RECORD &&
                        activeTab === FeedbackEntry.RECORD_DETAIL)
                        ? "rgba(255,199,18,0.1)"
                        : "",
                  }}
                  onClick={() => handleClickTab(item.value)}
                >
                  <span
                    className="text-sm font-medium text-[#666666]"
                    style={{
                      color:
                        activeTab === item.value ||
                        (item.value === FeedbackEntry.RECORD &&
                          activeTab === FeedbackEntry.RECORD_DETAIL)
                          ? globalToken.colorPrimary
                          : "",
                    }}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </Col>
          <Col flex={1}>
            {activeTab === FeedbackEntry.FEEDBACK && (
              <div className="w-full h-full box-border p-4 bg-[#FAFAFA] overflow-y-auto">
                <FeedbackForm ref={formRef} onSuccess={handleSubmitSuccess} />
              </div>
            )}
            {activeTab === FeedbackEntry.RECORD && (
              <div className="w-full h-full box-border p-4 bg-[#FAFAFA] overflow-y-auto">
                <FeedbackList onClickItem={handleClickFeedbackItem} />
              </div>
            )}
            {activeTab === FeedbackEntry.RECORD_DETAIL && (
              <div className="w-full h-full box-border bg-[#FAFAFA] overflow-y-auto">
                <FeedbackDetail data={feedbackData} onBack={handleBackList} />
              </div>
            )}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default HeaderFeedback;
